import ReactSearchInput from 'react-search-input'
import React from 'react'
import './SearchInput.less'

/**
 * Search-input component
 * It wraps React-Search-Input component
 */
export default class SearchInput extends React.Component {
  render () {
    return <ReactSearchInput
      className='infra-search-input'
      type='text'
      {...this.props}
      ref='ReactSearchInput' />
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SearchInput/index.js